import React, { useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import Chart from 'chart.js/auto';
import { DisclaimersRow } from '../Elements/DisclaimersRow';

import {
  COMPARE_YOUR_RESULTS,
  LOAN_OFFER_COMPARISON,
  OVERALL_PAYMENT_OVER_TIME,
  LINE,
  OVERALL_PAYMENT_DATA,
  OVERALL_PAYMENT_OPTIONS,
  BAR,
  INTEREST_RATE_COMPARISON_DATA,
  INTEREST_RATE_COMPARISON_OPTIONS,
} from '../../constants/Pages/Landing';

import { LOGO_DISCLAIMER, RATES_DISCLAIMER } from '../../constants/ComparisonSummary';

import './index.css';

export const CompareResults = ({
  interest_rate_comparison = INTEREST_RATE_COMPARISON_DATA,
  overall_payment_overtime = OVERALL_PAYMENT_DATA,
  loanTerm = null,
  legend = [],
  className,
}) => {
  useEffect(() => {
    const paymentCtx = document.getElementById('paymentChart').getContext('2d');

    if (Chart.getChart(paymentCtx)) {
      Chart.getChart(paymentCtx).destroy();
    }

    new Chart(paymentCtx, {
      type: LINE,
      data: overall_payment_overtime,
      options: OVERALL_PAYMENT_OPTIONS,
    });

    // Chart for Loan Offer Comparison
    const offerCtx = document.getElementById('offerChart').getContext('2d');

    if (Chart.getChart(offerCtx)) {
      Chart.getChart(offerCtx).destroy();
    }

    new Chart(offerCtx, {
      type: BAR,
      data: interest_rate_comparison,
      options: INTEREST_RATE_COMPARISON_OPTIONS,
    });
  }, [loanTerm]);

  return (
    <div className="compare-results-wrapper">
      <h2 className="compare-results-header">{COMPARE_YOUR_RESULTS}</h2>
      <div className="comparison-items-wrapper">
        <div className="comparison-item">
          <h4 className={`comparison-item-header ${className}`}>{LOAN_OFFER_COMPARISON}</h4>
          <canvas id="offerChart" className="comparison__chart"></canvas>
          {!!legend.length && (
            <div className="legend-logo-wrapper">
              {legend.map((leg) => (
                <div key={uuidv4()}>{leg}</div>
              ))}
            </div>
          )}
        </div>
        <div className="comparison-item">
          <h4 className={`comparison-item-header ${className}`}>{OVERALL_PAYMENT_OVER_TIME}</h4>
          <canvas id="paymentChart" className="comparison__chart"></canvas>
        </div>
      </div>
      {!!legend.length && (
        <DisclaimersRow LOGO_DISCLAIMER={LOGO_DISCLAIMER} RATES_DISCLAIMER={RATES_DISCLAIMER} />
      )}
    </div>
  );
};
